<div v-if="shouldRenderConfig" v-bind:class="getClassName" v-show="IsPreview2D">
    <button type="button" class="btn btn-primary" v-on:click="onDownload()">
        {{ $t('Download PDF') }}
    </button>    
</div>

